import * as devisConf from '@/configuration/devisConf';

export default function creerIntervenant(client) {
  const intervenant = {
    nomCommercial: client.nomCommercial,
    adressePostale: client.adressePostale,
    modeReglementId: client.modeReglementId,
    modeReglement: client.modeReglement,
    delaiReglementId: client.delaiReglementId,
    delaiReglement: client.delaiReglement,
    delaiReglementDetail: client.delaiReglementDetail,
    siret: client.siret,
    tvaIntracommunautaire: client.tvaIntracommunautaire,
    tiersId: client.id,
    payeur: false,
    donneurOrdre: false,
    mandataire: false,
    annonceur: false,
    repartition: null,
    titre: null,
    typeRepartition: devisConf.POURCENTAGE,
    tiers: client,
    role: client.role,
    compteComptable: client.compteComptable,
    factureParMail: client.factureParMail,
    applicationTva: client.applicationTva,
    nvClient: false,
  };
  intervenant.intervenantContacts = [];
  if (client.contacts && client.contacts.length > 0) {
    intervenant.contact = client.contacts[0];
    intervenant.contactId = client.contacts[0].id;
  }
  if (client.contacts && client.contacts.length === 1) {
    const contact = client.contacts[0];
    intervenant.intervenantContacts = [{
      contact,
      contactId: contact.id,
      contactTypes: contact.typesContactIds.map(tc => ({ typeContactId: tc })),
    }];
  }
  return intervenant;
}
